import type { Pt, Street } from '@chipless/shared';

/** 表示の整形。すべて日本語（要件12.8）。 */

const numberFormat = new Intl.NumberFormat('ja-JP');

export function pt(amount: Pt): string {
  return numberFormat.format(amount);
}

export function ptWithUnit(amount: Pt): string {
  return `${numberFormat.format(amount)}pt`;
}

const STREET_LABEL: Record<Street, string> = {
  PREFLOP: 'プリフロップ',
  FLOP: 'フロップ',
  TURN: 'ターン',
  RIVER: 'リバー',
  SHOWDOWN: 'ショーダウン',
  COMPLETE: 'ハンド終了',
};

export function streetLabel(street: Street): string {
  return STREET_LABEL[street];
}

export function seatLabel(seatNo: number): string {
  return `席${seatNo + 1}`;
}
